import { render, staticRenderFns } from "./BtnAddDescription.vue?vue&type=template&id=f404eea6&"
import script from "./BtnAddDescription.vue?vue&type=script&lang=js&"
export * from "./BtnAddDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports